import { createEntityAdapter, EntityState } from '@ngrx/entity';
import {
    ContractParticipantActions,
    ContractParticipantActionTypes,
} from '../../actions/mdqx/contract-participant.actions';
import { ContractParticipantEntity } from '../../../entities/mdqx/contract-participant.entity';

export interface ContractParticipantState extends EntityState<ContractParticipantEntity> {
    fetched: boolean;
}

export const CONTRACT_PARTICIPANT_KEY = 'contractParticipant';

const adapter = createEntityAdapter<ContractParticipantEntity>({
    selectId: contractParticipant => contractParticipant.Id,
});

const initialState: ContractParticipantState = adapter.getInitialState({
    fetched: false,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export function contractParticipantReducer(
    state = initialState,
    action: ContractParticipantActions,
) {
    switch (action.type) {
        case ContractParticipantActionTypes.GetResponse: {
            return adapter.setAll(action.Payload, { ...state, fetched: true });
        }

        case ContractParticipantActionTypes.PostResponse: {
            // setOne because we are updating an existing record if one with same customerId and ContractId already exists
            return adapter.setOne(action.Payload, state);
        }

        case ContractParticipantActionTypes.DeleteResponse: {
            return adapter.removeOne(action.Payload, state);
        }

        default: {
            return state;
        }
    }
}

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectAll } = adapter.getSelectors();

export const selectAllContractParticipants = selectAll;

export const selectContractParticipantsFetched = (state: ContractParticipantState) => state.fetched;
